
import { AclRoleAccess } from '../enums';

export const AclRoleAccesses = [
  { name: 'None', value: AclRoleAccess.None },
  { name: 'Read', value: AclRoleAccess.Read },
  { name: 'Write', value: AclRoleAccess.Write },
  { name: 'Full', value: AclRoleAccess.Full },
];


